import { Box, Container, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { useSnackbar } from "../CommonComponents/SnackbarProvider";
import { RawDataAction } from "../../actions/RawDataAction";
import LoadingComponent from "../CommonComponents/loadinComponent";
import TopView from "../CommonComponents/topView";
import EnhancedTableToolbar from "../CommonComponents/EnhancedTableToolbar";
import CommonTable from "../CommonComponents/CommanTable";
import ExportPdf from "../CommonComponents/exportPdf";
import CommanExcelExport from "../CommonComponents/CommanExcelExport";
import { useDebounce } from "../CommonComponents/useDebounce";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: "7rem",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  gridSpace: {
    margin: 0,
    width: "100%",
    marginBottom: "1rem",
  },
}));

const imeiresponce = {
  responseCode: 200,
  message: "OK",
  data: [
    "860",
    "860710085384306",
    "860710085384629",
    "860710085385873",
    "860710085386004",
    "860710085386012",
    "860710085386087",
    "860710085390733",
    "860710085391731",
    "860710085391855",
    "860710085391905",
    "860710085391970",

    "869523053846193",
    "HR26OB1336",
    "OD35D8619",
  ],
};

const rawDataResponce = {
  responseCode: 200,
  message: "OK",
  data: [
    {
      id: 94424948,
      devicename: "PT1404G",
      hexvalue:
        "244e524d2c505434472c574541312e302c4e522c30312c4c2c3836303731303038353531383837392c4f44323351393734342c312c31313132323032352c3030303231392c3032312e37363234303030302c4e2c3038332e38363838363333332c452c302e302c3131352e31302c33312c303231332e32342c31392e30302c302e33342c61697274656c2c312c312c32372e3538302c332e3730302c302c432c31392c3430352c35332c323334412c444339314330322c444339314330342c323334412c2d3130352c444339314330312c323334412c2d3131302c453632443830332c314131302c2d3131352c302c30302c30302c303031302c30302c302e3030302c302e3030302c3034333938382c3430382e3630372c2d2c312e302c302c302c3447415f325f395f435f315f305f315f305f302c36363730303236392a",
      packet:
        "$NRM,PT4G,WEA1.0,NR,01,L,860710085518879,OD23Q9744,1,11122025,000219,021.76240000,N,083.86886333,E,0.0,115.10,31,0213.24,19.00,0.34,airtel,1,1,27.580,3.700,0,C,19,405,53,234A,DC91C02,DC91C04,234A,-105,DC91C01,234A,-110,E62D803,1A10,-115,0,00,00,0010,00,0.000,0.000,043988,408.607,-,1.0,0,0,4GA_2_9_C_1_0_1_0_0,66700269*",
      imeinumber: "860710085518879",
      createddate: "2025-12-11T00:02:58.000+00:00",
    },
  ],
};

function RawDataList() {
  const { showSnackbar } = useSnackbar();
  const classes = useStyles();

  const [rawDataList, setRawDataList] = useState([]);
  const [imeiList, setImeiList] = useState([]);
  const [exportData, setExportData] = useState([]);

  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(200);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setLoading] = useState(false);

  const [imeiNo, setImeiNo] = useState("");
  // Change the initial state to have 2 minute difference
  const [fromDate, setFromDate] = useState(
    moment().subtract(30, "minutes").format("YYYY-MM-DDTHH:mm"),
  );
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DDTHH:mm"));

  const [openToolBar, setOpenToolBar] = useState(false);
  const [activeFilterCount, setActiveFilterCount] = useState(0);

  const [permissionAccess, setPermissionAccess] = React.useState(
    JSON.parse(sessionStorage.getItem("data")),
  );

  const rawdataMasterPer = permissionAccess.menuVisiblity.find(
    (menu) => menu.name === "RAW_DATA_MASTER",
  );

  useEffect(() => {
    fetchImeiList();
  }, []);

  useEffect(() => {
    let count = 0;
    if (imeiNo.trim() !== "") count++;
    if (fromDate.trim() !== "") count++;
    if (toDate.trim() !== "") count++;
    setActiveFilterCount(count);
  }, [imeiNo, fromDate, toDate]);

  const fetchImeiList = () => {
    RawDataAction.fetchImeiList(showSnackbar).then((response) => {
      if (response != null) {
        setImeiList(response.data || []);
      } else {
        setImeiList(response.data || []);
      }
    });
  };

  const fetchRawData = (type, exportType) => {
    if (!imeiNo) {
      showSnackbar("Please select an IMEI number", "error");
      return;
    }

    setLoading(true);

    const requestData = {
      imeiNo: imeiNo,
      fromDate: moment(fromDate).local().utc().format("YYYY-MM-DDTHH:mm:ss"),
      toDate: moment(toDate).local().utc().format("YYYY-MM-DDTHH:mm:ss"),

      pageNo: type ? pageNo : 0,
      pageSize: type ? pageSize : 200,
    };

    RawDataAction.fetchRawData(requestData, showSnackbar).then((response) => {
      // const response = rawDataResponce;

      console.log("yashresponce", response);
      if (response != null) {
        if (type) {
          const formattedData =
            response.data?.map((item, index) => ({
              sNo: pageNo * pageSize + index + 1,
              // Change: Use 'createddate' instead of 'createdDate'
              createdDate: moment(item.createddate).format(
                "DD-MM-YYYY HH:mm:ss",
              ),
              // Change: Use 'imeinumber' instead of 'imei'
              imei: item.imeinumber || "N/A",
              // Change: Use 'devicename' instead of 'deviceName'
              deviceName: item.devicename || "N/A",
              // Change: Use 'hexvalue' instead of 'hex'
              hex: item.hexvalue || "N/A",
              // packet field is correct as per response
              packet: item.packet || "N/A",
              rawItem: item,
            })) || [];

          setRawDataList(formattedData);
          setTotalPages(response.totalElements || 0);
        } else {
          const exportFormattedData =
            response.data?.map((item, index) => ({
              sNo: pageNo * pageSize + index + 1,
              // Change: Use 'createddate' instead of 'createdDate'
              createdDate: moment(item.createddate).format(
                "DD-MM-YYYY HH:mm:ss",
              ),
              // Change: Use 'imeinumber' instead of 'imei'
              imei: item.imeinumber || "N/A",
              // Change: Use 'devicename' instead of 'deviceName'
              deviceName: item.devicename || "N/A",
              // Change: Use 'hexvalue' instead of 'hex'
              hex: item.hexvalue || "N/A",
              // packet field is correct as per response
              packet: item.packet || "N/A",
              rawItem: item,
            })) || [];

          setExportData(exportFormattedData);

          if (exportType === "excel") {
            setTimeout(() => {
              document.getElementById("styleExportExcel").click();
              setLoading(false);
            }, 500);
          } else if (exportType === "pdf") {
            setTimeout(() => {
              document.getElementById("exportPdfButton").click();
              setLoading(false);
            }, 500);
          }
        }
      } else {
        if (type) {
          setRawDataList([]);
          setTotalPages(0);
        } else {
          setExportData([]);
        }
      }
      setLoading(false);
    });
  };

  const handleSearch = () => {
    if (!fromDate || !toDate) {
      showSnackbar(
        "Please ensure both the 'From' and 'To' dates are selected.",
        "error",
      );
      return;
    }
    if (fromDate && toDate && fromDate > toDate) {
      showSnackbar("From Date cannot be greater than To Date", "error");
      return;
    }

    if (!imeiNo) {
      showSnackbar("Please select an IMEI number", "error");
      return;
    } // Add date validation
    if (!validateDateDifference()) {
      return;
    }
    setPageNo(0);
    fetchRawData(true);
  };

  const handleChangePage = (event, newPage) => {
    setPageNo(newPage);
    fetchRawData(true);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setPageNo(0);
    fetchRawData(true);
  };

  const getExportData = (type) => {
    if (!imeiNo) {
      showSnackbar("Please select an IMEI number", "error");
      return;
    }
    if (!validateDateDifference()) {
      return;
    }
    fetchRawData(false, type);
  };

  const toggleOpenToolBar = () => {
    setOpenToolBar(!openToolBar);
  };

  const onChangeHandlersetImeiNo = (value) => {
    if (value === null) {
      setImeiNo("");
      return;
    }
    setImeiNo(value);
  };

  const validateDateDifference = () => {
    const from = moment(fromDate);
    const to = moment(toDate);
    const diffInMinutes = to.diff(from, "minutes");

    if (diffInMinutes > 30) {
      showSnackbar(
        "The difference between From Date and To Date should not be greater than 30 minutes",
        "error",
      );
      return false;
    }
    return true;
  };

  const labelHeader = [
    {
      name: "S. No",
      keyName: "sNo",
      isShow: true,
      isExportShow: true,
    },
    {
      name: "CREATED DATE",
      keyName: "createdDate",
      isShow: true,
      isExportShow: true,
    },
    {
      name: "IMEI",
      keyName: "imei",
      isShow: true,
      isExportShow: true,
    },
    {
      name: "DEVICE NAME",
      keyName: "deviceName",
      isShow: true,
      isExportShow: true,
    },
    {
      name: "HEX",
      keyName: "hex",
      isShow: true,
      isExportShow: true,
    },
    {
      name: "PACKET",
      keyName: "packet",
      isShow: true,
      isExportShow: true,
    },
  ];

  const dropdowns = [
    {
      label: "From Date",
      type: "date",
      valueKey: "fromDate",
      value: fromDate,
      placeholder: "Enter date",
      dateType: "datetime-local",
      onChangeHandler: setFromDate,
    },
    {
      label: "To Date",
      type: "date",
      valueKey: "toDate",
      value: toDate,
      placeholder: "Enter Date",
      dateType: "datetime-local",
      onChangeHandler: setToDate,
    },
    {
      label: "IMEI No",
      type: "autocomplete",
      options: imeiList || [],
      valueKey: "name",
      value: imeiNo,
      placeholder: "Select IMEI",
      onChangeHandler: onChangeHandlersetImeiNo,
    },

    {
      label: "",
      type: "button",
      buttonText: "Submit",
      buttonVariant: "contained",
      buttonClass: "ml-1",
      onClickHandler: handleSearch,
    },
  ];

  const topViewData = {
    title: "Raw Data Master",
    subTitleFirst: "Dashboard >",
    subTitleThird: "Raw Data Master",
    buttonIcon: true,
    backPath: "/dashboard",
    addButtonPath: "",
    addButtonPermission: false,
    export: rawdataMasterPer?.exportPermission,
    showPdfButton: rawdataMasterPer?.exportPermission,
    showExcelButton: rawdataMasterPer?.exportPermission,
    getExportData: getExportData,
    openToolBar,
    toggleOpenToolBar,
    hasActiveFilters: activeFilterCount > 0,
    activeFilterCount: activeFilterCount,
    showSearchButton: true,
  };

  return (
    <div className="makeStylesRoot" style={{ position: "relative" }}>
      <LoadingComponent isLoading={isLoading} />
      <Container>
        <TopView data={topViewData} />

        <div style={{ display: "none" }}>
          <CommanExcelExport
            headers={labelHeader.filter((h) => h.isShow)}
            rows={Array.isArray(exportData) ? exportData : [exportData]}
            exportHeading={["Raw Data Report"]}
            reportType={"RawDataList"}
          />
          <ExportPdf
            headers={labelHeader.filter((h) => h.isShow)}
            rows={exportData || []}
            title="Raw Data Report"
            reportName="RawDataList"
            customColumnWidths={{
              hex: 150, // Width for HEX column in points
              packet: 200, // Width for PACKET column in points
            }}
          />
        </div>

        <EnhancedTableToolbar
          dropdowns={dropdowns}
          drawerOpen={openToolBar}
          setDrawerOpen={setOpenToolBar}
        />

        <Grid className="tableSection">
          <CommonTable
            headers={labelHeader.filter((h) => h.isShow)}
            rows={rawDataList || []}
            pageNo={pageNo}
            setPageNo={setPageNo}
            totalPages={totalPages}
            pageSize={pageSize}
            setPageSize={setPageSize}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            isLoading={isLoading}
            isShowPagination={false}
            emptyMessage={
              imeiNo
                ? "No data found for the selected filters"
                : "Please select an IMEI number to view data"
            }
          />
        </Grid>
      </Container>
    </div>
  );
}

export default RawDataList;
